import noop from 'lodash-es/noop';
import type { PropsWithChildren } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

interface ProductsTableContext {
  canEditProducts?: boolean;
  setCanEditProducts: (canEdit: boolean) => void;
}

const ProductsTableContext = createContext<ProductsTableContext>({
  setCanEditProducts: noop,
});
ProductsTableContext.displayName = 'ProductsTable';

export const useProductsTable = () => useContext(ProductsTableContext);

export const ProductsTableProvider = ({ children }: PropsWithChildren) => {
  // Catchall for published/unpublished/hidden permissions, switches based on currently selected table
  const [canEditProducts, setCanEditProducts] = useState(false);

  const contextValue = useMemo(
    () => ({
      canEditProducts,
      setCanEditProducts,
    }),
    [canEditProducts, setCanEditProducts]
  );

  return (
    <ProductsTableContext.Provider value={contextValue}>
      {children}
    </ProductsTableContext.Provider>
  );
};
